module.exports = __webpack_public_path__ + "img/logo.dcd3a58a.svg";